import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  row: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
  yellowButton: {
    background: "var(--app-primary)",
  },
  iconButton: {
    // background: "rgba(255, 186, 69, 0.85)", // yellow
    padding: "6px 15px",
    borderRadius: "5px",
    marginInline: 5,
    display: "flex",
    alignItems: "center",
  },
  documentsContent: {
    borderRadius: "10px",
    backgroundColor: "var(--app-surface-2)",
    margin: "20px",
    padding: "20px",
    "@media (max-width: 480px)": {
      margin: "10px",
      padding: "12px",
    },
  },
  activeAndInactiveTab: {
    "& .mantine-Tabs-tabsList": {
      backgroundColor: "transparent",
      borderBottom: "0.125rem solid var(--app-border)",
      borderRadius: 0,
      padding: "0px",
      "& .mantine-Tabs-tab": {
        borderBottom: "none",
        backgroundColor: "transparent",
      },
      "& .mantine-Tabs-tab[data-active]": {
        backgroundColor: "transparent !important",
      },
    },
  },
  notFoundTextContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "60vh",
    gap: "8rem",
    width: "100%",
    "@media (max-width: 480px)": {
      height: "auto",
      gap: "2rem",
      padding: "2rem 0",
    },
  },
  notFoundText: {
    color: "var(--app-text-muted)",
    marginTop: 40,
  },
}));

export default useStyles;
